import styled from 'styled-components';

export const VehicleInfoDrawerContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const TitleWrapper = styled.div`
    padding-right: 10px;
    padding-top: 5px;
    .ids-status-indicator-root div {
        top: 1px;
        right: -3px;
    }
`;
